<section class="dashboard-page">
  <div class="hero-panel">
    <div class="hero-copy">
      <p class="eyebrow">Admin Command Center</p>
      <h1>Dashboard overview for {{ currentUser?.username || 'admin' }}</h1>
      <p class="hero-text">
        Keep a close view on platform growth, published inventory, incoming leads, and callback demand from a
        single screen.
      </p>

      <div class="hero-meta">
        <div class="meta-chip">
          <mat-icon>verified_user</mat-icon>
          <span>{{ currentUser?.role || 'ADMIN' }}</span>
        </div>
        <div class="meta-chip">
          <mat-icon>update</mat-icon>
          <span>{{ formatTimestamp(lastUpdated()) }}</span>
        </div>
      </div>

      <div class="hero-actions">
        <button mat-raised-button type="button" routerLink="/property/rent/manage">Review properties</button>
        <button mat-stroked-button type="button" routerLink="/users/all">Manage users</button>
      </div>
    </div>

    <div class="hero-highlight">
      <div class="highlight-shell">
        <span class="highlight-label">Callback load</span>
        <strong>{{ stats().totalCallbackRequests }}</strong>
        <p>Owner callback and contact-us callback requests are aggregated here.</p>
      </div>
    </div>
  </div>

  @if (errorMessage()) {
  <div class="status-banner error-banner">
    <div>
      <strong>Dashboard data is unavailable.</strong>
      <p>{{ errorMessage() }}</p>
    </div>
    <button mat-stroked-button type="button" (click)="loadStats()">Retry</button>
  </div>
  }

  @if (isLoading()) {
  <div class="status-banner loading-banner">
    <mat-icon>hourglass_top</mat-icon>
    <span>Loading the latest dashboard stats...</span>
  </div>
  }

  <div class="stats-grid">
    @for (card of statCards; track card.title) {
    <mat-card class="stat-card" [ngClass]="card.accentClass">
      <div class="stat-header">
        <div>
          <p class="stat-title">{{ card.title }}</p>
          <h2>{{ card.value }}</h2>
        </div>
        <div class="stat-icon">
          <mat-icon>{{ card.icon }}</mat-icon>
        </div>
      </div>
      <p class="stat-description">{{ card.description }}</p>
    </mat-card>
    }
  </div>

  <div class="insights-grid">
    <mat-card class="insight-card">
      <div class="section-heading">
        <div>
          <p class="section-label">Operational Snapshot</p>
          <h3>What the numbers mean</h3>
        </div>
        <mat-icon>insights</mat-icon>
      </div>

      <div class="insight-list">
        <div class="insight-row">
          <span class="insight-dot users-dot"></span>
          <p><strong>{{ stats().totalUsers }}</strong> active platform users, excluding admin accounts.</p>
        </div>
        <div class="insight-row">
          <span class="insight-dot leads-dot"></span>
          <p><strong>{{ stats().totalLeads }}</strong> total leads currently captured by the admin system.</p>
        </div>
        <div class="insight-row">
          <span class="insight-dot properties-dot"></span>
          <p><strong>{{ stats().totalPublishedProperties }}</strong> properties are available in published state.</p>
        </div>
        <div class="insight-row">
          <span class="insight-dot callbacks-dot"></span>
          <p><strong>{{ stats().totalCallbackRequests }}</strong> callback requests combine owner and contact-us flows.</p>
        </div>
      </div>
    </mat-card>

    <mat-card class="quick-actions-card">
      <div class="section-heading">
        <div>
          <p class="section-label">Quick Actions</p>
          <h3>Jump into daily work</h3>
        </div>
        <mat-icon>bolt</mat-icon>
      </div>

      <div class="quick-link-list">
        @for (link of quickLinks; track link.title) {
        <a class="quick-link" [routerLink]="link.route">
          <div class="quick-link-icon">
            <mat-icon>{{ link.icon }}</mat-icon>
          </div>
          <div class="quick-link-copy">
            <h4>{{ link.title }}</h4>
            <p>{{ link.description }}</p>
          </div>
          <span class="quick-link-action">{{ link.actionLabel }}</span>
        </a>
        }
      </div>
    </mat-card>
  </div>
</section>
